import { useEffect, useRef } from "react"

import classnames from "classnames"

import { checkPermissions } from "api"
import { useAppDispatch, useAppSelector } from "lib/hooks"

import styles from "./VideoFeed.module.scss"

const stop = () => {
  window.stream = window.stream || {}
  window.stream.getTracks?.().forEach(track => {
    track.stop()
  })
}

const VideoFeed = () => {
  const dispatch = useAppDispatch()
  const calls = useAppSelector(state => state.tokbox)
  const videoElement = useRef<HTMLVideoElement>(null)

  const gotStream = (stream?: MediaStream) => {
    if (stream) {
      window.stream = stream // make stream available to console
      if (videoElement.current) videoElement.current.srcObject = stream
    }
  }

  useEffect(() => {
    stop()
    dispatch(checkPermissions(stream => gotStream(stream), false))
  }, [dispatch, calls.pubOptions])

  return (
    <div className={styles.player}>
      <video
        id="video"
        className={classnames(styles.video, styles.mirrored)}
        style={{ display: "block" }}
        muted
        autoPlay
        ref={videoElement}>
        <track kind="captions" />
      </video>
    </div>
  )
}
export default VideoFeed
